var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pollComponent)?_c('div',{staticClass:"poll-score",class:{
    'poll-score--rating': _vm.isRating,
    'poll-score--fill-height': _vm.fillHeight,
  }},[_c(_vm.pollComponent,{tag:"component",attrs:{"chart":_vm.poll,"poll-chain":_vm.pollChain,"is-voting":_vm.isVoting,"use-colors":true}})],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }